module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":{"edit":"レビュー修正","delete":"レビュー削除"},"password":{"placeholder":"レビューを作成する際に設定したパスワードを入力してください。","invalid":"パスワードが正しくありません。"},"submit":{"edit":"レビュー修正","delete":"レビュー削除"}}}')
  delete Component.options._Ctor
}
